// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2qySW","buttons":"Footer_buttons__3UWHT"};